import React, {
  FunctionComponent, useCallback, useEffect, useRef, useState,
} from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import {
  CopyableText, Heading, Loading, Subtitle,
} from '../../components';
import api from '../../api';
import { useAppState, useNotification } from '../../hooks';

export interface ICredentials {
  username: string;
  password: string;
  token?: string;
}

const CcsInit: FunctionComponent<{}> = () => {
  const [resp, setResp] = useState<ICredentials>();
  const [isLoading, setLoading] = useState(false);
  const { accountId } = useAppState();
  const { addNotification } = useNotification();
  const isMounted = useRef<boolean>(false);

  const doInit = useCallback(async () => {
    if (isMounted.current) {
      setLoading(true);
    }
    try {
      const creds = await api.ccsV2.initAccount(accountId);
      if (isMounted.current) {
        setLoading(false);
        setResp(creds);
      }
    } catch (err) {
      setLoading(false);
      addNotification(err, 'error');
    }
  }, [addNotification, accountId]);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (accountId) {
      doInit();
    }
  }, [accountId, doInit]);

  if (!isLoading && !resp) {
    return <Text variant="primary">Failed</Text>;
  }

  return (
    <Box>
      <Heading>CCS Initialization</Heading>
      <Subtitle mb={4}>
        Use this page to initialize your CCS V2 account
      </Subtitle>
      {isLoading ? (
        <Flex alignItems="center" justifyContent="center" mb={3} mt={4} height="100%">
          <Loading size={24} />
        </Flex>
      ) : (
        <Flex sx={{ color: 'white' }} flexDirection="column" p={3}>
          <Flex mb={4}>
            <Box height="42px" mr={4}>
              <Text variant="primary" mb={1}>Username</Text>
              <CopyableText text={resp?.username} copyEnabled={!!resp?.username} />
            </Box>
            <Box height="42px">
              <Text variant="primary" mb={1}>Password</Text>
              <CopyableText text={resp?.password} copyEnabled={!!resp?.password} />
            </Box>
          </Flex>
          <Box height="42px" mt={4}>
            <Text variant="primary" mb={1}>Token</Text>
            <CopyableText text={resp?.token} copyEnabled={!!resp?.token} />
          </Box>
        </Flex>
      )}
    </Box>

  );
};

export default CcsInit;
